import React from 'react';
import { Routes, Route } from 'react-router-dom';
import TerminalBar from './components/TerminalBar';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Showroom from './pages/Showroom';
import Build from './pages/Build';
import Highway from './pages/Highway';
import Manifesto from './pages/Manifesto';
import Economics from './pages/Economics';
import CorporateGateway from './pages/CorporateGateway';

function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <TerminalBar />
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/showroom" element={<Showroom />} />
          <Route path="/build/:id" element={<Build />} />
          <Route path="/highway" element={<Highway />} />
          <Route path="/manifesto" element={<Manifesto />} />
          <Route path="/economics" element={<Economics />} />
          <Route path="/gateway" element={<CorporateGateway />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;